import pizza from '@/assets/pizza.png';
import carbonara from '@/assets/carbonara.png';
import bolognese from '@/assets/bolognese.png';
import tiramisu from '@/assets/tiramisu.png';
import pescatore from '@/assets/pescatore.png';

export const menuItems = [
  {
    id: 1,
    name: "薪窯マルゲリータ",
    nameEn: "Margherita",
    description: "ナポリ産サンマルツァーノトマトと新鮮なモッツァレラ、自家栽培バジルを贅沢に使った当店の看板メニュー。480℃の薪窯で90秒、外はパリッと中はもっちり焼き上げます。",
    price: "¥1,980",
    image: pizza,
    featured: true,
  },
  {
    id: 2,
    name: "カルボナーラ",
    nameEn: "Carbonara",
    description: "平飼い卵黄と24ヶ月熟成ペコリーノロマーノのみで仕上げるローマ伝統の味。グアンチャーレの旨味と黒胡椒の香りが絡み合う、シンプルだからこそ奥深い一皿。",
    price: "¥1,780",
    image: carbonara,
    featured: false,
  },
  {
    id: 3,
    name: "ボロネーゼ",
    nameEn: "Bolognese",
    description: "イタリア産牛肉を赤ワインでじっくり6時間煮込んだ濃厚ラグーソース。幅広のタリアテッレに絡めて、削りたてパルミジャーノをたっぷりと。",
    price: "¥1,880",
    image: bolognese,
    featured: false,
  },
  {
    id: 4,
    name: "ペスカトーレ",
    nameEn: "Pescatore",
    description: "新鮮な有頭エビ、ムール貝、アサリを白ワインで蒸し上げた漁師風パスタ。魚介のエキスが染み出たトマトソースが絶品、仕上げにイタリアンパセリを散らして。",
    price: "¥2,280",
    image: pescatore,
    featured: true,
  },
  {
    id: 5,
    name: "ティラミス",
    nameEn: "Tiramisu",
    description: "エスプレッソを染み込ませたビスコッティと、軽やかなマスカルポーネクリームが層をなすドルチェの王様。仕上げにヴァローナココアパウダーをふわり。",
    price: "¥980",
    image: tiramisu,
    featured: false,
  },

];

export const restaurantInfo = {
  name: "Trattoria Sole",
  nameJp: "トラットリア ソーレ",
  address: "東京都渋谷区恵比寿西1-8-12 恵比寿ガーデンプラザ 1F",
  phone: "03-1234-5678",
  email: "info@trattoria-sole.com",
  seats: 42,
  privateRoom: "8名様個室あり",
  businessHours: {
    lunch: "11:30 〜 15:00（L.O. 14:00）",
    dinner: "17:30 〜 23:00（L.O. 22:00）",
  },
  holidays: "毎週火曜日・第2水曜日",
  access: {
    station: "JR恵比寿駅 西口より徒歩5分",
    parking: "提携駐車場あり（2時間無料）",
    mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.9!2d139.71!3d35.6466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzXCsDM4JzQ3LjgiTiAxMznCsDQyJzM2LjAiRQ!5e0!3m2!1sja!2sjp!4v1690000000000",
  },
};